import { getATLContextDomain } from '@atlassian/atl-context';

/**
 * Returns a link to the Admin base URL depending on the environment
 * e.g: prod -> https://admin.atlassian.com, staging -> https://admin.stg.atlassian.com
 */
export const getAdminBaseUrl = () => `https://${getATLContextDomain('admin')}`;
